/** Filters copied from WhatsApp Manager → Message templates → Template library. */

export const LIBRARY_LANGUAGES = [
  { label: "English (US)", value: "en_US" },
  { label: "English (UK)", value: "en_GB" },
  { label: "Hindi", value: "hi" },
  { label: "Spanish", value: "es" },
  { label: "Portuguese (BR)", value: "pt_BR" },
  { label: "Arabic", value: "ar" },
  { label: "Indonesian", value: "id" },
  { label: "French", value: "fr" },
  { label: "German", value: "de" },
  { label: "Italian", value: "it" },
  { label: "Turkish", value: "tr" },
];

export const LIBRARY_CATEGORIES = [
  { value: "utility", label: "Utility" },
  { value: "authentication", label: "Authentication" },
];

const INDUSTRY_GROUP = {
  id: "industry",
  label: "Industry",
  field: "industries",
  defaultOpen: false,
  options: [
    { value: "E_COMMERCE", label: "E-commerce" },
    { value: "FINANCIAL_SERVICES", label: "Financial services" },
    { value: "TELECOMMUNICATION", label: "Telecommunication" },
  ],
};

export const LIBRARY_FILTER_GROUPS_BY_CATEGORY = {
  utility: [
    INDUSTRY_GROUP,
    {
      id: "feature",
      label: "Feature",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "FORMS", label: "Forms" },
        { value: "CATALOG", label: "Catalog" },
        { value: "APPOINTMENT", label: "Appointments" },
      ],
    },
    {
      id: "account_protection",
      label: "Account or product protection",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "FRAUD_ALERT", label: "Fraud awareness" },
        { value: "TRANSACTION_ALERT", label: "Transaction alert" },
        { value: "LOW_BALANCE_WARNING", label: "Low balance warning" },
        { value: "PRODUCT_RECALL", label: "Product recalls" },
        { value: "WARRANTY_ALERT", label: "Warranty alerts" },
      ],
    },
    {
      id: "account_updates",
      label: "Account updates",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "ACCOUNT_CREATION_CONFIRMATION", label: "Account creation confirmation" },
        { value: "ACCOUNT_UPDATE", label: "Account updates" },
        { value: "ACCOUNT_UPDATES", label: "Account update alerts" },
        { value: "ADDRESS_UPDATE", label: "Address update" },
        { value: "STATEMENT_AVAILABLE", label: "Statement available" },
        { value: "STATEMENT_ATTACHMENT", label: "Statement attachment" },
        { value: "RECEIPT_ATTACHMENT", label: "Receipt attachment" },
      ],
    },
    {
      id: "call_permissions",
      label: "Call permissions",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "CALL_PERMISSION_REQUEST", label: "Call permission request" },
        { value: "VOICE_CALL", label: "Voice call" },
        { value: "VIDEO_CALL", label: "Video call" },
        { value: "WHATSAPP_CALLING", label: "WhatsApp calling" },
      ],
    },
    {
      id: "customer_feedback",
      label: "Customer Feedback",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "CUSTOMER_FEEDBACK", label: "Customer feedback" },
        { value: "FEEDBACK_SURVEY", label: "Feedback survey" },
        { value: "ORDER_FEEDBACK", label: "Order feedback" },
        { value: "VISIT_FEEDBACK", label: "Visit feedback" },
      ],
    },
    {
      id: "event_reminder",
      label: "Event reminder",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "EVENT_REMINDER", label: "Event reminder" },
        { value: "APPOINTMENT_REMINDER", label: "Appointment reminder" },
        { value: "WEBINAR_REMINDER", label: "Webinar reminder" },
        { value: "CLASS_REMINDER", label: "Class reminder" },
      ],
    },
    {
      id: "group_invite",
      label: "Group invite link",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "GROUP_INVITE", label: "Group invite" },
        { value: "COMMUNITY_INVITE", label: "Community invite" },
      ],
    },
    {
      id: "legal_compliance",
      label: "Legal / regulatory compliance",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "IDENTITY_COMPLIANCE", label: "Identity compliance" },
        { value: "PRIVACY_DISCLOSURE", label: "Privacy disclosures" },
        { value: "WARRANTY_ALERT", label: "Warranty alerts" },
      ],
    },
    {
      id: "order_management",
      label: "Order management",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "ORDER_MANAGEMENT", label: "Order management" },
        { value: "ORDER_CONFIRMATION", label: "Order confirmation" },
        { value: "ORDER_ACTION_NEEDED", label: "Order action needed" },
        { value: "ORDER_DELAY", label: "Order delay" },
        { value: "ORDER_OR_TRANSACTION_CANCEL", label: "Order or transaction cancelled" },
        { value: "ORDER_PICK_UP", label: "Order pick-up" },
        { value: "SHIPMENT_CONFIRMATION", label: "Shipment confirmation" },
        { value: "DELIVERY_CONFIRMATION", label: "Delivery confirmation" },
        { value: "DELIVERY_UPDATE", label: "Delivery update" },
        { value: "DELIVERY_FAILED", label: "Delivery failed" },
        { value: "RETURN_CONFIRMATION", label: "Return confirmation" },
      ],
    },
    {
      id: "payments",
      label: "Payments",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "PAYMENTS", label: "Payments" },
        { value: "PAYMENT_ACTION_REQUIRED", label: "Payment action required" },
        { value: "PAYMENT_CONFIRMATION", label: "Payment confirmation" },
        { value: "PAYMENT_DUE_REMINDER", label: "Payment due reminder" },
        { value: "PAYMENT_OVERDUE", label: "Payment overdue" },
        { value: "PAYMENT_REJECT_FAIL", label: "Payment rejected or failed" },
        { value: "PAYMENT_SCHEDULED", label: "Payment scheduled" },
        { value: "AUTO_PAY_REMINDER", label: "Auto-pay reminder" },
      ],
    },
    {
      id: "public_disruption",
      label: "Public disruption",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "SYSTEM_OUTAGE", label: "System outages" },
        { value: "OPERATIONAL_DISRUPTION", label: "Operational disruption" },
      ],
    },
    {
      id: "public_safety",
      label: "Public safety",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "SEVERE_WEATHER", label: "Severe weather" },
        { value: "CRISIS_RESPONSE", label: "Crisis response" },
      ],
    },
    {
      id: "public_service",
      label: "Public service",
      field: "usecase",
      defaultOpen: false,
      options: [
        { value: "HEALTH_AWARENESS", label: "Health awareness" },
        { value: "HEALTH_EMERGENCY", label: "Health emergency" },
        { value: "VOTING_REGISTRATION", label: "Voting registration" },
        { value: "DISBURSEMENTS", label: "Disbursements" },
      ],
    },
  ],
  authentication: [
    INDUSTRY_GROUP,
    {
      id: "auth_feature",
      label: "Feature",
      field: "authFeature",
      defaultOpen: false,
      options: [
        { value: "COPY_CODE", label: "Copy code" },
        { value: "ONE_TAP", label: "One-tap autofill" },
        { value: "ZERO_TAP", label: "Zero-tap" },
        { value: "SECURITY_RECOMMENDATION", label: "Security recommendation" },
        { value: "EXPIRATION_WARNING", label: "Expiration warning" },
      ],
    },
    {
      id: "auth_usecase",
      label: "Use case",
      field: "authUsecase",
      defaultOpen: false,
      options: [
        { value: "ACCOUNT_VERIFICATION", label: "Account verification" },
        { value: "ACCOUNT_RECOVERY", label: "Account recovery" },
        { value: "INTEGRITY_CHALLENGE", label: "Integrity challenges" },
        { value: "NEW_ACCOUNT_CREATION", label: "New account creation" },
        { value: "ORDER_OR_TRANSACTION", label: "Orders or transactions" },
      ],
    },
  ],
};

export const OPTION_MATCHERS = {
  E_COMMERCE: ["E_COMMERCE", "ECOMMERCE"],
  FINANCIAL_SERVICES: ["FINANCIAL_SERVICES", "FINANCE"],
  TELECOMMUNICATION: ["TELECOMMUNICATION", "TELECOMMUNICATIONS", "TELECOM"],
  APPOINTMENT: ["APPOINTMENT", "APPOINTMENTS", "RESERVATION", "BOOKING"],
  CUSTOMER_FEEDBACK: ["CUSTOMER_FEEDBACK", "FEEDBACK"],
  FEEDBACK_SURVEY: ["FEEDBACK_SURVEY", "SURVEY"],
  ORDER_FEEDBACK: ["ORDER_FEEDBACK"],
  VISIT_FEEDBACK: ["VISIT_FEEDBACK", "STORE_FEEDBACK"],
  FORMS: ["FORMS", "FLOW", "FORM"],
  CATALOG: ["CATALOG", "MPM"],
  EVENT_REMINDER: ["EVENT_REMINDER", "EVENT"],
  APPOINTMENT_REMINDER: ["APPOINTMENT_REMINDER"],
  WEBINAR_REMINDER: ["WEBINAR_REMINDER", "WEBINAR"],
  CLASS_REMINDER: ["CLASS_REMINDER", "CLASS"],
  GROUP_INVITE: ["GROUP_INVITE", "GROUP_LINK", "INVITE_LINK"],
  COMMUNITY_INVITE: ["COMMUNITY_INVITE", "COMMUNITY"],
  IDENTITY_COMPLIANCE: ["IDENTITY_COMPLIANCE", "IDENTITY", "KYC"],
  PRIVACY_DISCLOSURE: ["PRIVACY_DISCLOSURE", "PRIVACY_POLICY", "PRIVACY"],
  SYSTEM_OUTAGE: ["SYSTEM_OUTAGE", "OUTAGE"],
  OPERATIONAL_DISRUPTION: ["OPERATIONAL_DISRUPTION", "DISRUPTION"],
  SEVERE_WEATHER: ["SEVERE_WEATHER", "WEATHER", "TORNADO"],
  CRISIS_RESPONSE: ["CRISIS_RESPONSE", "CRISIS"],
  HEALTH_AWARENESS: ["HEALTH_AWARENESS", "VACCINE", "HEALTH"],
  HEALTH_EMERGENCY: ["HEALTH_EMERGENCY"],
  VOTING_REGISTRATION: ["VOTING_REGISTRATION", "VOTER"],
  DISBURSEMENTS: ["DISBURSEMENTS", "WELFARE"],
  ORDER_MANAGEMENT: ["ORDER_MANAGEMENT"],
  ORDER_CONFIRMATION: ["ORDER_CONFIRMATION"],
  ORDER_ACTION_NEEDED: ["ORDER_ACTION_NEEDED"],
  ORDER_DELAY: ["ORDER_DELAY"],
  ORDER_OR_TRANSACTION_CANCEL: ["ORDER_OR_TRANSACTION_CANCEL", "CANCEL"],
  ORDER_PICK_UP: ["ORDER_PICK_UP", "PICK_UP", "PICKUP"],
  PAYMENTS: ["PAYMENTS", "PAYMENT"],
  PAYMENT_ACTION_REQUIRED: ["PAYMENT_ACTION_REQUIRED"],
  PAYMENT_CONFIRMATION: ["PAYMENT_CONFIRMATION"],
  PAYMENT_DUE_REMINDER: ["PAYMENT_DUE_REMINDER"],
  PAYMENT_OVERDUE: ["PAYMENT_OVERDUE"],
  PAYMENT_REJECT_FAIL: ["PAYMENT_REJECT_FAIL", "PAYMENT_REJECT", "PAYMENT_FAIL"],
  PAYMENT_SCHEDULED: ["PAYMENT_SCHEDULED"],
  AUTO_PAY_REMINDER: ["AUTO_PAY_REMINDER", "AUTOPAY"],
  SHIPMENT_CONFIRMATION: ["SHIPMENT_CONFIRMATION", "SHIPMENT"],
  DELIVERY_CONFIRMATION: ["DELIVERY_CONFIRMATION"],
  DELIVERY_UPDATE: ["DELIVERY_UPDATE"],
  DELIVERY_FAILED: ["DELIVERY_FAILED"],
  RETURN_CONFIRMATION: ["RETURN_CONFIRMATION", "RETURN"],
  FRAUD_ALERT: ["FRAUD_ALERT", "FRAUD"],
  TRANSACTION_ALERT: ["TRANSACTION_ALERT"],
  LOW_BALANCE_WARNING: ["LOW_BALANCE_WARNING", "LOW_BALANCE"],
  PRODUCT_RECALL: ["PRODUCT_RECALL", "RECALL"],
  WARRANTY_ALERT: ["WARRANTY_ALERT", "WARRANTY"],
  ACCOUNT_CREATION_CONFIRMATION: ["ACCOUNT_CREATION_CONFIRMATION", "ACCOUNT_CREATION"],
  ACCOUNT_UPDATE: ["ACCOUNT_UPDATE"],
  ACCOUNT_UPDATES: ["ACCOUNT_UPDATES"],
  ADDRESS_UPDATE: ["ADDRESS_UPDATE", "ADDRESS"],
  STATEMENT_AVAILABLE: ["STATEMENT_AVAILABLE"],
  STATEMENT_ATTACHMENT: ["STATEMENT_ATTACHMENT"],
  RECEIPT_ATTACHMENT: ["RECEIPT_ATTACHMENT", "RECEIPT"],
  CALL_PERMISSION_REQUEST: ["CALL_PERMISSION_REQUEST", "CALL_PERMISSION"],
  VOICE_CALL: ["VOICE_CALL"],
  VIDEO_CALL: ["VIDEO_CALL"],
  WHATSAPP_CALLING: ["WHATSAPP_CALLING", "CALLING"],
  COPY_CODE: ["COPY_CODE", "OTP"],
  ONE_TAP: ["ONE_TAP", "AUTOFILL"],
  ZERO_TAP: ["ZERO_TAP"],
  SECURITY_RECOMMENDATION: ["SECURITY_RECOMMENDATION", "SECURITY"],
  EXPIRATION_WARNING: ["EXPIRATION_WARNING", "EXPIRATION"],
  ACCOUNT_VERIFICATION: ["ACCOUNT_VERIFICATION", "VERIFY", "VERIFICATION"],
  ACCOUNT_RECOVERY: ["ACCOUNT_RECOVERY", "RECOVERY"],
  INTEGRITY_CHALLENGE: ["INTEGRITY_CHALLENGE", "INTEGRITY"],
  NEW_ACCOUNT_CREATION: ["NEW_ACCOUNT_CREATION", "NEW_ACCOUNT"],
  ORDER_OR_TRANSACTION: ["ORDER_OR_TRANSACTION", "TRANSACTION"],
};

export const LIBRARY_FILTER_GROUPS = LIBRARY_FILTER_GROUPS_BY_CATEGORY.utility;

export const META_TOPICS = [
  "ACCOUNT_UPDATES",
  "CUSTOMER_FEEDBACK",
  "ORDER_MANAGEMENT",
  "PAYMENTS",
];

export const META_USECASES = [
  "ACCOUNT_CREATION_CONFIRMATION",
  "AUTO_PAY_REMINDER",
  "DELIVERY_CONFIRMATION",
  "DELIVERY_FAILED",
  "DELIVERY_UPDATE",
  "FEEDBACK_SURVEY",
  "FRAUD_ALERT",
  "LOW_BALANCE_WARNING",
  "ORDER_ACTION_NEEDED",
  "ORDER_CONFIRMATION",
  "ORDER_DELAY",
  "ORDER_OR_TRANSACTION_CANCEL",
  "ORDER_PICK_UP",
  "PAYMENT_ACTION_REQUIRED",
  "PAYMENT_CONFIRMATION",
  "PAYMENT_DUE_REMINDER",
  "PAYMENT_OVERDUE",
  "PAYMENT_REJECT_FAIL",
  "PAYMENT_SCHEDULED",
  "RECEIPT_ATTACHMENT",
  "RETURN_CONFIRMATION",
  "SHIPMENT_CONFIRMATION",
  "STATEMENT_ATTACHMENT",
  "STATEMENT_AVAILABLE",
  "TRANSACTION_ALERT",
];

export const META_INDUSTRIES = [
  "E_COMMERCE",
  "FINANCIAL_SERVICES",
  "TELECOMMUNICATION",
];

export const GROUP_META_TOPIC = {
  customer_feedback: "CUSTOMER_FEEDBACK",
  order_management: "ORDER_MANAGEMENT",
  payments: "PAYMENTS",
  account_updates: "ACCOUNT_UPDATES",
};

export const GRAPH_SEARCH = {
  FORMS: "form",
  CATALOG: "catalog",
  APPOINTMENT: "appointment",
  PRODUCT_RECALL: "recall",
  WARRANTY_ALERT: "warranty",
  ACCOUNT_UPDATE: "account update",
  ADDRESS_UPDATE: "address",
  CALL_PERMISSION_REQUEST: "call permission",
  VOICE_CALL: "voice call",
  VIDEO_CALL: "video call",
  WHATSAPP_CALLING: "calling",
  EVENT_REMINDER: "event reminder",
  APPOINTMENT_REMINDER: "appointment reminder",
  WEBINAR_REMINDER: "webinar",
  CLASS_REMINDER: "class reminder",
  GROUP_INVITE: "group invite",
  COMMUNITY_INVITE: "community invite",
  IDENTITY_COMPLIANCE: "identity",
  PRIVACY_DISCLOSURE: "privacy",
  SYSTEM_OUTAGE: "outage",
  OPERATIONAL_DISRUPTION: "disruption",
  SEVERE_WEATHER: "weather",
  CRISIS_RESPONSE: "crisis",
  HEALTH_AWARENESS: "health",
  HEALTH_EMERGENCY: "emergency",
  VOTING_REGISTRATION: "voting",
  DISBURSEMENTS: "disbursement",
  ORDER_FEEDBACK: "order feedback",
  VISIT_FEEDBACK: "visit feedback",
  COPY_CODE: "otp",
  ONE_TAP: "one tap",
  ZERO_TAP: "zero tap",
  SECURITY_RECOMMENDATION: "security",
  EXPIRATION_WARNING: "expiration",
  ACCOUNT_VERIFICATION: "verification",
  ACCOUNT_RECOVERY: "recovery",
  INTEGRITY_CHALLENGE: "integrity",
  NEW_ACCOUNT_CREATION: "new account",
  ORDER_OR_TRANSACTION: "transaction",
};

export function graphQueryForFilter(group, value) {
  if (group?.field === "industries" && META_INDUSTRIES.includes(value)) {
    return { industry: value };
  }
  if (META_USECASES.includes(value)) return { usecase: value };
  if (META_TOPICS.includes(value)) return { topic: value };
  if (GROUP_META_TOPIC[group?.id] && value === GROUP_META_TOPIC[group.id]) {
    return { topic: GROUP_META_TOPIC[group.id] };
  }
  if (GRAPH_SEARCH[value]) return { search: GRAPH_SEARCH[value] };
  const label = String(value || "")
    .replace(/_/g, " ")
    .toLowerCase();
  return { search: label };
}

const TITLE_OVERRIDES = {
  account_creation_confirmation_3: "Finalize account set-up",
  address_update: "Address update",
};

export function humanizeLibraryName(name = "") {
  return String(name)
    .replace(/_\d+$/, "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (ch) => ch.toUpperCase());
}

export function formatLibraryBody(text = "") {
  return String(text)
    .replace(/\{\{\d+\}\}/g, "{{text}}")
    .replace(/\{\{([^}]+)\}\}/g, (_, token) => `{{${String(token).trim()}}}`);
}

function asList(value) {
  if (Array.isArray(value)) {
    return value.map((item) => String(item || "").toUpperCase()).filter(Boolean);
  }
  if (value) return [String(value).toUpperCase()];
  return [];
}

function normalizeIndustry(value) {
  const raw = String(value || "")
    .toUpperCase()
    .replace(/[\s-]+/g, "_");
  if (raw === "ECOMMERCE" || raw === "E_COMMERCE") return "E_COMMERCE";
  if (
    raw === "FINANCE" ||
    raw === "FINANCIAL_SERVICES" ||
    raw === "FINANCIALSERVICES"
  ) {
    return "FINANCIAL_SERVICES";
  }
  if (
    raw === "TELECOM" ||
    raw === "TELECOMMUNICATION" ||
    raw === "TELECOMMUNICATIONS"
  ) {
    return "TELECOMMUNICATION";
  }
  return raw;
}

function detectAuthFeature(item, buttons) {
  const blob = JSON.stringify({
    name: item.name,
    buttons,
    otp: item.otp_type,
  }).toUpperCase();
  if (blob.includes("ZERO_TAP")) return "ZERO_TAP";
  if (blob.includes("ONE_TAP") || blob.includes("AUTOFILL")) return "ONE_TAP";
  if (blob.includes("COPY_CODE") || blob.includes("OTP")) return "COPY_CODE";
  return "";
}

function detectAuthUsecase(item) {
  const blob = `${item.name || ""} ${item.topic || ""} ${item.usecase || ""}`.toUpperCase();
  if (blob.includes("RECOVERY")) return "ACCOUNT_RECOVERY";
  if (blob.includes("INTEGRITY")) return "INTEGRITY_CHALLENGE";
  if (blob.includes("VERIFY") || blob.includes("OTP") || blob.includes("AUTH")) {
    return "ACCOUNT_VERIFICATION";
  }
  return String(item.usecase || "").toUpperCase();
}

export function mapManagerLibraryItem(item = {}, source = "meta") {
  const name = item.name || item.templateName || "";
  const buttons = Array.isArray(item.buttons)
    ? item.buttons
    : Array.isArray(item.interactiveActions)
      ? item.interactiveActions
      : [];
  const body = item.body || item.templateFormat || "";
  const header = item.header || TITLE_OVERRIDES[name] || "";
  const bodyParams = Array.isArray(item.body_params) ? item.body_params : [];
  let category = String(item.category || "").toLowerCase();
  if (!category) {
    category = /otp|auth|verify_code|copy_code/i.test(name)
      ? "authentication"
      : "utility";
  }
  return {
    source,
    id: item.id || name,
    name,
    title: header || TITLE_OVERRIDES[name] || humanizeLibraryName(name),
    header,
    body,
    language: item.language || "en_US",
    category,
    topic: String(item.topic || "").toUpperCase(),
    usecase: String(item.usecase || "").toUpperCase(),
    industries: asList(item.industry || item.industries).map(normalizeIndustry),
    authFeature: detectAuthFeature(item, buttons),
    authUsecase: detectAuthUsecase(item),
    buttonTypes: buttons.map((button) => String(button.type || "").toUpperCase()),
    buttons: buttons.map((button) => ({
      type: button.type || (category === "authentication" ? "OTP" : "URL"),
      title: button.title || button.text || (category === "authentication" ? "Copy code" : "Continue"),
      value: button.value || button.url || button.phone_number || "",
    })),
    sampleValues:
      item.sampleValues ||
      bodyParams.reduce((acc, value, index) => {
        acc[index + 1] = value;
        return acc;
      }, {}),
    templateName: name,
    templateType: item.templateType || "Text",
    templateFormat: body,
    footerText: item.footer || item.footerText || "",
    interactiveActions: buttons.map((button) => ({
      type: button.type || "URL",
      title: button.title || button.text || "",
      value: button.value || button.url || button.phone_number || "",
      countrycode: button.countrycode || "",
    })),
  };
}

export function toCreateTemplateState(item) {
  return {
    category: item.category || "utility",
    language: item.language,
    templateName: item.templateName || item.name,
    templateType: item.templateType || "Text",
    templateFormat: item.body || item.templateFormat || "",
    footerText: item.footerText || "",
    interactiveActions: item.interactiveActions || item.buttons || [],
    sampleValues: item.sampleValues || {},
    authFeature: item.authFeature || "",
    library_template_name: item.source === "meta" ? item.name : undefined,
  };
}
